export default function SVGEdit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="11.75" fill="white" stroke="#BCBCBC" strokeWidth="0.5" />
      <path
        d="M8.84166 15.5746C8.72478 15.5744 8.61336 15.5251 8.53458 15.4387C8.45435 15.3531 8.41448 15.2373 8.425 15.1204L8.52708 13.9979L13.2429 9.28376L14.7167 10.7571L10.0021 15.4708L8.87958 15.5729C8.86666 15.5742 8.85375 15.5746 8.84166 15.5746ZM15.0108 10.4625L13.5375 8.98918L14.4213 8.10543C14.4994 8.02719 14.6055 7.98322 14.716 7.98322C14.8266 7.98322 14.9327 8.02719 15.0108 8.10543L15.8946 8.98918C15.9728 9.06733 16.0168 9.17338 16.0168 9.28397C16.0168 9.39456 15.9728 9.50061 15.8946 9.57876L15.0113 10.4621L15.0108 10.4625Z"
        fill="#BCBCBC"
      />
    </svg>
  );
}
